/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import SaveSimulationPricingsGroupHealthMutation from '../graphql/mutations/SaveSimulationPricingsGroupHealthMutation.js';

export const useSaveSimulationPricingsGroupHealthMutation = () => {
  return useCommitMutation(SaveSimulationPricingsGroupHealthMutation, {
    dataProp: 'saveSimulationPricingsGroupHealth_M_simulation_pricings_group_health'
  });
};

export default useSaveSimulationPricingsGroupHealthMutation;
